const languages = () => ({
  en: { name: 'English' },
  ja: { name: '日本語' },
  vi: { name: 'Tiếng Việt' },
  // Add/remove languages in this object
});

export default languages;
